import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Order } from '../../models/order.model';
import { ProductOrder } from '../../models/product-order.model';
import { UploadService } from '../../services/upload.service';
import { OrderService } from '../../services/order.service';

@Component({
    selector: 'app-force-status',
    templateUrl: './force-status.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ForceStatusComponent implements OnInit {
  public order: Order;
  public hasAllBat?: boolean = null;
  public progress = false;

  constructor(
    public dialogRef: MatDialogRef<ForceStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { order: Order },
    private orderService: OrderService,
    private uploadService: UploadService) {
  }

  ngOnInit(): void {
    this.order = this.data.order;
    this.checkProofs();
  }

  /**
   * Close dialog without action
   */
  cancel(): void {
    this.dialogRef.close(false);
  }

  /**
   * Call API to force order status -> Waiting For Validation
   */
  edit(): void {
    this.progress = true;
    this.orderService.forceValidation(this.order.id)
      .then(() => this.dialogRef.close(true))
      .catch(err => console.error(err))
      .finally(() => this.progress = false);
  }

  /**
   * Check if all products have a proof files
   */
  private checkProofs(): void {
    if (this.order.batIsActive) {
      this.progress = true;
      Promise.all(this.order.products.map(product => this.hasBat(product)))
        .then(res => this.hasAllBat = res.every(r => r))
        .catch(err => {
          console.error(err);
          throw err;
        })
        .finally(() => this.progress = false);
    }
  }

  /**
   * Check if a product have a proof file
   * @param product The product to check
   * @returns True if a proof file exists else False
   */
  private async hasBat(product: ProductOrder): Promise<boolean> {
    const path = product.poFiles[0]?.path.replace('.pdf', '-bat.pdf');
    if (!path) {
      return false;
    }
    return this.uploadService.exists(path);
  }
}
